import React, { useEffect, useState } from "react";
import BreadCrumpBack from "../../../components/navigator/back";
import { user_challenge_opportunity_list } from "../../user/user.api";
import "../careers/tenders.css";

function ChallengesOpportunities(props) {
  const [data, setData] = useState([]);

  const parseDueDate = (value) => {
    if (!value) return null;
    const str = String(value).trim();
    if (!str) return null;

    // Handle known formats explicitly first to avoid browser-dependent parsing
    // (e.g. new Date("01/11/2026") may be treated as mm/dd/yyyy in some browsers)
    const slashParts = str.split("/");
    if (slashParts.length === 3) {
      const [a, b, c] = slashParts;
      // yyyy/mm/dd
      if (a && a.length === 4) {
        const dt = new Date(`${a}-${b}-${c}`);
        return Number.isNaN(dt.getTime()) ? null : dt;
      }
      // dd/mm/yyyy
      if (c && c.length === 4) {
        const dt = new Date(`${c}-${b}-${a}`);
        return Number.isNaN(dt.getTime()) ? null : dt;
      }
    }

    const dashParts = str.split("-");
    if (dashParts.length === 3) {
      const [a, b, c] = dashParts;
      // yyyy-mm-dd
      if (a && a.length === 4) {
        const dt = new Date(`${a}-${b}-${c}`);
        return Number.isNaN(dt.getTime()) ? null : dt;
      }
      // dd-mm-yyyy
      if (c && c.length === 4) {
        const dt = new Date(`${c}-${b}-${a}`);
        return Number.isNaN(dt.getTime()) ? null : dt;
      }
    }

    // Try native parsing next (handles ISO like 2026-04-29T10:20:30Z)
    const native = new Date(str);
    if (!Number.isNaN(native.getTime())) return native;

    return null;
  };

  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);

  const visibleData = data.filter((item) => {
    const due = parseDueDate(item?.due_date);
    if (!due) return true;
    due.setHours(0, 0, 0, 0);
    return due >= todayStart;
  });

  const assetBaseUrl = (process.env.REACT_APP_BASE_URL || "").replace(
    /\/api\/?$/,
    ""
  );

  useEffect(() => {
    user_challenge_opportunity_list().then((res) => {
      const rows = Array.isArray(res)
        ? res
        : Array.isArray(res?.data)
        ? res?.data
        : [];

      const mapped = rows
        .filter(
          (x) =>
            String(x?.status).toLowerCase() === "approved" ||
            String(x?.status) === "1"
        )
        .map((item) => ({
          ...item,
          opportunity:
            item?.market_analysis_opportunity?.opportunity ??
            item?.market_analysis_opportunity_name ??
            item?.opportunity ??
            "",
          image: item?.image || "",
          brochure: item?.brochure || "",
        }));

      setData(mapped);
    });
  }, []);

  const handleLink = (linkurl) => {
    if (!linkurl) return;
    const urlLower = String(linkurl).toLowerCase();
    const urlStart = urlLower.substring(0, 4);
    if (urlStart === "http") {
      window.open(`${urlLower}`, "_blank");
    } else {
      window.open(`//${urlLower}`, "_blank");
    }
  };

  return (
    <>
      <div className="container-fluid event-bg">
        <div className="row m-55">
          <h3>
            {props.state.language === "ma"
              ? "ചലഞ്ചുകളും അവസരങ്ങളും"
              : "Challenges/Opportunities"}
          </h3>
        </div>
      </div>
      <BreadCrumpBack />
      <div className="container-fluid">
        <div className="table-container overflow-auto">
          <table className="">
            {visibleData.length > 0 ? (
              <tr className="">
                <th className="table-head">
                  {props.state.language === "ma" ? "അവസരം" : "Opportunity"}
                </th>
                <th className="table-head">
                  {props.state.language === "ma" ? "തലക്കെട്ട്" : "Title"}
                </th>
                <th className="table-head">
                  {props.state.language === "ma" ? "വിവരണം" : "Description"}
                </th>
                <th className="table-head" style={{ width: "120px" }}>
                  {props.state.language === "ma" ? "അവസാന തീയതി" : "Due Date"}
                </th>
                <th className="table-head" style={{ width: "120px" }}>
                  {props.state.language === "ma" ? "ലിങ്ക്" : "Link"}
                </th>
                <th className="table-head" style={{ width: "120px" }}>
                  {props.state.language === "ma" ? "ബ്രോഷർ" : "Brochure"}
                </th>
                <th className="table-head" style={{ width: "120px" }}>
                  {props.state.language === "ma" ? "ചിത്രം" : "Image"}
                </th>
              </tr>
            ) : (
              <div
                className="d-flex justify-content-center"
                style={{ fontSize: "20px" }}
              >
                No Recent Postings
              </div>
            )}
            {visibleData.map((card) => {
              return (
                <>
                  <tr>
                    <td className="m-2 text-left">
                      {card?.opportunity || "-"}
                    </td>
                    <td className="m-2 text-left">{card?.title || "-"}</td>
                    <td className="m-2 text-left">
                      {card?.description || "-"}
                    </td>
                    <td className="m-2 text-left">{card?.due_date || "-"}</td>
                    <td className="m-2 text-left">
                      {card?.site_url ? (
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleLink(card.site_url);
                          }}
                          className="break_link"
                        >
                          {props.state.language === "ma" ? "കാണുക" : "Open"}
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="m-2 text-left">
                      {card?.brochure ? (
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            // Use the brochure URL directly as it's already complete
                            const url = card.brochure;
                            
                            // Extract filename from URL
                            const filename = url.split('/').pop() || 'brochure.pdf';
                            
                            // Create download link
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = filename;
                            
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }}
                          className="break_link"
                          style={{ cursor: 'pointer' }}
                        >
                          {props.state.language === "ma"
                            ? "ഡൗൺലോഡ്"
                            : "Download"}
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="m-2 text-left">
                      {card?.image ? (
                        <img
                          src={card.image}
                          alt=""
                          style={{ width: "80px", height: "60px", objectFit: "cover" }}
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                </>
              );
            })}
          </table>
        </div>
      </div>
    </>
  );
}

export default ChallengesOpportunities;
